import CSS from 'csstype';
import React from 'react';

import {
  getCustomTag,
  getFlexDirection,
  getResponsiveStyle,
  getSpacingStyle,
  ILayoutProps,
  ISpacingProps,
  mediaSize,
  spacing,
} from '~/src/dash/components/layout/common';
import { useBaseState } from '~/src/dash/views/base/contexts';

interface IRowsProps extends ILayoutProps, ISpacingProps {
  max?: boolean;
  gap?: string;
  colBreakSize?: mediaSize;
}

export const Rows = ({
  max,
  gap,
  colBreakSize,
  noPadding,
  extraSmallPadding,
  smallPadding,
  basePadding,
  largePadding,
  extraLargePadding,
  hugePadding,
  noHorizontalPadding,
  extraSmallHorizontalPadding,
  smallHorizontalPadding,
  horizontalPadding,
  largeHorizontalPadding,
  extraLargeHorizontalPadding,
  hugeHorizontalPadding,
  noVerticalPadding,
  extraSmallVerticalPadding,
  smallVerticalPadding,
  verticalPadding,
  largeVerticalPadding,
  extraLargeVerticalPadding,
  hugeVerticalPadding,
  extraSmallPaddingV2,
  smallPaddingV2,
  basePaddingV2,
  largePaddingV2,
  extraLargePaddingV2,
  hugePaddingV2,
  noHorizontalPaddingV2,
  extraSmallHorizontalPaddingV2,
  smallHorizontalPaddingV2,
  horizontalPaddingV2,
  largeHorizontalPaddingV2,
  extraLargeHorizontalPaddingV2,
  hugeHorizontalPaddingV2,
  noVerticalPaddingV2,
  extraSmallVerticalPaddingV2,
  smallVerticalPaddingV2,
  verticalPaddingV2,
  largeVerticalPaddingV2,
  extraLargeVerticalPaddingV2,
  hugeVerticalPaddingV2,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  style,
  responsive,
  extraLargeStyle,
  largeStyle,
  mediumStyle,
  smallStyle,
  extraSmallStyle,
  children,
  innerRef,
  className = '',
  tag,
  cypressID,
}: IRowsProps) => {
  const mediaSize = responsive ? useBaseState().mediaSize : 'extraSmall';
  const flexDirection = getFlexDirection(colBreakSize, mediaSize, 'column');
  const addOptionalStyles = () => {
    const styles = {} as CSS.Properties;
    if (max) {
      styles.position = 'absolute';
      styles.minHeight = '100%';
      styles.minWidth = '100%';
    }
    if (gap) {
      if (flexDirection === 'row') {
        styles.columnGap = gap;
      } else {
        styles.rowGap = gap;
      }
    }
    return styles;
  };

  return (
    <div
      ref={innerRef}
      className={className}
      data-cy={cypressID}
      style={{
        ...getCustomTag('ROWS', tag),
        display: 'flex',
        flexDirection,
        position: 'relative',
        ...addOptionalStyles(),
        ...getSpacingStyle({
          defaultPadding: spacing.none,
          noPadding,
          extraSmallPadding,
          smallPadding,
          basePadding,
          largePadding,
          extraLargePadding,
          hugePadding,
          noHorizontalPadding,
          extraSmallHorizontalPadding,
          smallHorizontalPadding,
          horizontalPadding,
          largeHorizontalPadding,
          extraLargeHorizontalPadding,
          hugeHorizontalPadding,
          noVerticalPadding,
          extraSmallVerticalPadding,
          smallVerticalPadding,
          verticalPadding,
          largeVerticalPadding,
          extraLargeVerticalPadding,
          hugeVerticalPadding,
          extraSmallPaddingV2,
          smallPaddingV2,
          basePaddingV2,
          largePaddingV2,
          extraLargePaddingV2,
          hugePaddingV2,
          noHorizontalPaddingV2,
          extraSmallHorizontalPaddingV2,
          smallHorizontalPaddingV2,
          horizontalPaddingV2,
          largeHorizontalPaddingV2,
          extraLargeHorizontalPaddingV2,
          hugeHorizontalPaddingV2,
          noVerticalPaddingV2,
          extraSmallVerticalPaddingV2,
          smallVerticalPaddingV2,
          verticalPaddingV2,
          largeVerticalPaddingV2,
          extraLargeVerticalPaddingV2,
          hugeVerticalPaddingV2,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          marginTop,
          marginRight,
          marginBottom,
          marginLeft,
        }),
        ...style,
        ...getResponsiveStyle({
          responsive,
          mediaSize,
          extraLargeStyle,
          largeStyle,
          mediumStyle,
          smallStyle,
          extraSmallStyle,
        }),
      }}
    >
      {children}
    </div>
  );
};
